module.exports = __webpack_public_path__ + "img/62.5fce8140.jpg";